import telegram from '../images/telegram.png';
import x from '../images/x.png';
import dex from '../images/dex.png';
import scroll from '../images/scroll.png';

const tgLink = 'https://t.me/deusgate';
const xLink = 'https://x.com/valueandculture';
const dexLink = 'https://dexscreener.com/solana/FsKUS8j884k9AhAQxbCTMrLWX341hVXKT8M8G8b1pump';
const redPaperLink = 'https://x.com/valueandculture/status/1877143103313777112';

function Footer() {
  const iconSize = '36px';
  return (
    <div style={{
      position: 'absolute',
      bottom: '10px',
      left: '50%',
      transform: 'translateX(-50%)',
      fontFamily: 'Cinzel, serif',
      fontSize: '24px',
      color: '#da0000',
      textTransform: 'uppercase',
      letterSpacing: '2px',
      display: 'flex',
      gap: '50px',
      textShadow: `
        2px 2px 4px rgba(139, 0, 0, 0.7)  /* Dark red shadow for depth */
      `
    }}>
      <a href={xLink} target="_blank" rel="noopener noreferrer">
        <img src={x} alt="Twitter" style={{ width: iconSize, height: iconSize, cursor: 'pointer' }} />
      </a>
      {/* <a href={tgLink} target="_blank" rel="noopener noreferrer">
        <img src={telegram} alt="Telegram" style={{ width: iconSize, height: iconSize, cursor: 'pointer' }} />
      </a> */}
      <a href={dexLink} target="_blank" rel="noopener noreferrer">
        <img src={dex} alt="Dex Screener" style={{ width: iconSize, height: iconSize, cursor: 'pointer' }} />
      </a>
      <a href={redPaperLink} target="_blank" rel="noopener noreferrer">
        <img src={scroll} alt="Dex Screener" style={{ width: iconSize, height: iconSize, cursor: 'pointer' }} />
      </a>
    </div>
  );
}

export default Footer; 